export const REFCOME_LOGIN_URL = `https://refcome.com/managers/sign_in`;
export const PRIVACY_POLICY_URL = `https://jp.refcome.com/privacy/statement`;
export const PRIVACY_POLICY_MARKETING_URL = `https://jp.refcome.com/privacy`;

/** フォーム送信不可時の問い合わせ先（フォーム下案内で表示） */
export const CONTACT_FALLBACK = {
  email: process.env.GATSBY_CONTACT_EMAIL || "marketing@refcome.com",
  tel: "03-5656-9966",
  telHours: "平日10:00〜17:00",
} as const;
/** HubSpot 日程調整のベースURL（クエリはページ側で付与） */
export const HUBSPOT_MEETING_BOOKING_BASE_URL =
  `https://meetings-na2.hubspot.com/masahiro-sekiguchi/mkt-rr-zoom`;

/**
 * オンライン相談ページへの流入元パラメータ
 * - website: サイト内ボタン（ヘッダー・トップなど）
 * - document: 資料（PDFなど）内のリンク
 */
export const MEETING_BOOKING_UTM = {
  website: {
    utm_source: "website",
    utm_medium: "cta",
  },
  document: {
    utm_source: "document",
    utm_medium: "pdf",
  },
} as const;

/** /meeting へのパスをクエリ付きで生成する */
export const meetingBookingPath = (utm: { utm_source: string; utm_medium: string }): string => {
  const params = new URLSearchParams(utm);
  return `/meeting?${params.toString()}`;
};

/**
 * ページURLのクエリを HubSpot 埋め込みURLへ引き継ぐ
 * （utm_source / utm_medium などで流入元を判別できるようにする）
 */
export const buildHubSpotMeetingEmbedUrl = (pageSearch = ""): string => {
  const url = new URL(HUBSPOT_MEETING_BOOKING_BASE_URL);
  url.searchParams.set("service", "Refcome");
  url.searchParams.set("embed", "true");

  const pageParams = new URLSearchParams(pageSearch.startsWith("?") ? pageSearch.slice(1) : pageSearch);
  pageParams.forEach((value, key) => {
    if (key === "embed") return;
    url.searchParams.set(key, value);
  });

  return url.toString();
};

export const PATH = {
  TOP: {
    name: `トップ`,
    to: `/`,
  },
  INSIGHT: {
    name: `ブログ`,
    to: `/insight`,
  },
  CASES: {
    name: `導入事例`,
    to: `/cases`,
  },
  AWARD: {
    name: `Referral Recruiting Award`,
    to: `/awards`,
  },
  AWARD_2020: {
    name: `第3回受賞企業インタビュー`,
    to: `/awards/2020`,
  },
  AWARD_2023: {
    name: `第4回受賞企業インタビュー`,
    to: `/awards/2023`,
  },
  AWARD_2024: {
    name: `第5回受賞企業インタビュー`,
    to: `/awards/2024`,
  },
  AWARD_2025: {
    name: `第6回受賞企業インタビュー`,
    to: `/awards/2025`,
  },
  EVENTS: {
    name: `セミナー・イベント`,
    to: `/events`,
  },
  EVENTS_SEMINAR: {
    name: `セミナー情報`,
    to: `/events/seminar`,
  },
  EVENTS_REPORT: {
    name: `イベントレポート`,
    to: `/events/report`,
  },
  EVENTS_AWARD: {
    name: `Referral Recruiting Award`,
    to: `/events/award`,
  },
  EVENTS_AWARD_ENTRY: {
    name: `エントリーフォーム`,
    to: `/events/award/entry`,
  },
  EVENTS_AWARD_2018: {
    name: `第2回受賞企業インタビュー`,
    to: `/events/award/interview2018`,
  },
  EVENTS_AWARD_2017: {
    name: `第1回受賞企業インタビュー`,
    to: `/events/award/interview2017`,
  },
  DOWNLOADS: {
    name: `お役立ち資料`,
    to: `/downloads`,
  },
  REQUEST: {
    name: `サービスについての資料請求・お問い合わせ`,
    to: `/request`,
  },
  INQUIRY_CONTACT: {
    name: `お問い合わせ`,
    to: `/inquiry/contact`,
  },
  MEETING_BOOKING: {
    name: `オンライン相談のご予約`,
    to: `/meeting`,
    /** サイト内ボタン用（ヘッダー・トップなど） */
    websiteTo: meetingBookingPath(MEETING_BOOKING_UTM.website),
    /** 資料内リンク用（PDFなどに掲載） */
    documentTo: meetingBookingPath(MEETING_BOOKING_UTM.document),
  },
  PARTNER_APPLICATION: {
    name: `販売パートナー応募`,
    to: `/partner-application`,
  },
  TAGS: {
    name: `タグ`,
    to: `/tags`,
  },
};

/** タグ別一覧ページのパスを生成する */
export const tagPath = (slug: string): string => `/tags/${slug}`;
